import { Component, Output, EventEmitter, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NetWorthTrendWidgetComponent } from '../../../features/dashboard/widgets/net-worth-trend-widget/net-worth-trend-widget';
import { CashFlowPreviewWidgetComponent } from '../../../features/dashboard/widgets/cash-flow-preview-widget/cash-flow-preview-widget';
import { SavingsGoal } from '../../../features/dashboard/widgets/savings-goal/savings-goal';
import { SpendingSnapshotWidgetComponent } from '../../../features/dashboard/widgets/spending-snapshot-widget/spending-snapshot-widget';
import { AiAdviceWidgetComponent } from '../../../features/dashboard/widgets/ai-advice-widget/ai-advice-widget';
import { AiChatWidgetComponent } from '../../../features/dashboard/widgets/ai-chat-widget/ai-chat-widget';
import { DebtsSummaryWidgetComponent } from '../../../features/dashboard/widgets/debts-summary-widget/debts-summary-widget';
import { UpcomingBills } from '../../../features/dashboard/widgets/upcoming-bills/upcoming-bills';
import { InvestmentOverviewWidgetComponent } from '../../../features/dashboard/widgets/investment-overview-widget/investment-overview-widget';
import { AccountSummary } from '../../../features/dashboard/widgets/account-summary/account-summary';
import { BudgetStatus } from '../../../features/dashboard/widgets/budget-status/budget-status';
import { ExpenseTotalWidgetComponent } from '../../../features/dashboard/widgets/expense-total-widget/expense-total-widget';
import { ExpenseTracker } from '../../../features/dashboard/widgets/expense-tracker/expense-tracker';
import { TotalBalanceWidget } from '../../../features/dashboard/widgets/total-balance/total-balance';
import { MyCards } from '../../../features/dashboard/widgets/my-cards/my-cards';
import { DealsOffers } from '../../../features/dashboard/widgets/deals-offers/deals-offers';
import { LoanOffersWidgetComponent } from '../../../features/dashboard/widgets/loan-offers-widget/loan-offers-widget';
import { CardOffersWidget } from '../../../features/dashboard/widgets/card-offers/card-offers';
import { InsuranceOffers } from '../../../features/dashboard/widgets/insurance-offers/insurance-offers';
import { TodaysExpenseTotalComponent } from '../../../features/dashboard/widgets/todays-expense-total/todays-expense-total';
import { LifetimeExpense } from '../../../features/dashboard/widgets/lifetime-expense/lifetime-expense';
import { EnergyExpense } from '../../../features/dashboard/widgets/energy-expense/energy-expense';
import { Loans } from '../../../features/dashboard/widgets/loans/loans';
import { InvestmentValue } from '../../../features/dashboard/widgets/investment-value/investment-value';


@Component({
  selector: 'app-add-widgets-modal',
  standalone: true,
  imports: [
    CommonModule,
    NetWorthTrendWidgetComponent,
    CashFlowPreviewWidgetComponent,
    SavingsGoal,
    SpendingSnapshotWidgetComponent,
    AiAdviceWidgetComponent,
    AiChatWidgetComponent,
    DebtsSummaryWidgetComponent,
    UpcomingBills,
    InvestmentOverviewWidgetComponent,
    AccountSummary,
    BudgetStatus,
    ExpenseTotalWidgetComponent,
    ExpenseTracker,
    TotalBalanceWidget,
    MyCards,
    DealsOffers,
    LoanOffersWidgetComponent,
    CardOffersWidget,
    InsuranceOffers,
    TodaysExpenseTotalComponent,
    LifetimeExpense,
    EnergyExpense,
    Loans,
    InvestmentValue
  ],

  templateUrl: './add-widgets-modal.html',
  styleUrl: './add-widgets-modal.scss',
})
export class AddWidgetsModal {
  @Input() activeWidgets: any[] = [];

  readonly ALL_WIDGET_TYPES = [
    'networthtrend', 'cashflowpreview', 'savings', 'spending',
    'aiadvice', 'aichat', 'debts', 'bills', 'budget',
    'expensetotal', 'investmentoverview', 'expensetracker',
    'balance', 'todayexpensetotal', 'lifetimeexpense', 'energyexpense',
    'mycards', 'accountsummary', 'dealsoffers', 'loanoffers',
    'cardoffers', 'insurance', 'loans', 'investmentvalue'
  ];

  isAddMode = true;
  selectedFilter: 'small' | 'medium' | 'large' | 'extra-large' = 'large';

  @Output() close = new EventEmitter<void>();
  @Output() addWidgetRequest = new EventEmitter<string>();

  onClose() {
    this.close.emit();
  }

  onAddWidget(type: string) {
    this.addWidgetRequest.emit(type);
  }

  isWidgetActive(type: string): boolean {
    return this.activeWidgets.some(w => w.type === type);
  }

  get isAllWidgetsActive(): boolean {
    return this.ALL_WIDGET_TYPES.every(type => this.isWidgetActive(type));
  }

  setFilter(filter: 'small' | 'medium' | 'large' | 'extra-large') {
    this.selectedFilter = filter;
  }
}
